// extracted by mini-css-extract-plugin
module.exports = {"component":"WheelPackage_component__T5qml"};